import { Component, Input } from '@angular/core';

/**
 * Empty-state placeholder for sections that don't have backing functionality yet.
 * Optional `legacyHref` lets us link users to the working surface in the legacy CMODashboard.
 */
@Component({
    standalone: false,
    selector: 'mkt-ws-coming-soon',
    template: `
<div class="cs">
    <i class="fa-solid {{ icon }} cs__icon"></i>
    <h3 class="cs__title">{{ title }}</h3>
    <p class="cs__body" *ngIf="body">{{ body }}</p>
    <p class="cs__legacy" *ngIf="legacyLabel">
        Available today in
        <a *ngIf="legacyHref" [href]="legacyHref">{{ legacyLabel }}</a>
        <span *ngIf="!legacyHref">{{ legacyLabel }}</span>.
    </p>
</div>
    `,
    styles: [`
        :host { display: block; }
        .cs { display: flex; flex-direction: column; align-items: center; justify-content: center; padding: 80px 20px; text-align: center; background: var(--mj-bg-surface, #fff); border: 1px solid var(--mj-border-default, #e0e0e0); border-radius: 10px; }
        .cs__icon { font-size: 36px; color: var(--mj-text-disabled, #aaa); margin-bottom: 16px; }
        .cs__title { font-size: 18px; font-weight: 600; margin: 0 0 8px; color: var(--mj-text-primary, #1a1a1a); }
        .cs__body { max-width: 480px; margin: 0; font-size: 13px; line-height: 1.6; color: var(--mj-text-secondary, #71717a); }
        .cs__legacy { margin: 16px 0 0; font-size: 12px; color: var(--mj-text-secondary, #71717a); }
        .cs__legacy a { color: var(--mj-brand-primary, #6366f1); text-decoration: none; font-weight: 500; }
        .cs__legacy a:hover { text-decoration: underline; }
    `]
})
export class ComingSoonComponent {
    @Input() title = 'Coming soon';
    @Input() body = '';
    @Input() icon = 'fa-clock';
    @Input() legacyLabel = '';
    @Input() legacyHref = '';
}
